export default __webpack_public_path__ + "static/media/bg.71247272.mp4";